import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#09090B] text-white/80">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link
          to="/login"
          className="inline-flex items-center text-white/40 hover:text-white/70 text-sm mb-8 transition-colors"
          data-testid="terms-back-link"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour
        </Link>

        <h1 className="font-heading text-3xl md:text-4xl font-bold text-white mb-2">
          Conditions d{"'"}utilisation
        </h1>
        <p className="text-white/40 text-sm mb-10">
          Derniere mise a jour : 8 avril 2026
        </p>

        <div className="space-y-8 text-[15px] leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Acceptation des conditions</h2>
            <p>
              En accedant et en utilisant Forfaits Vacances Tracker ({'"'}trackvacances.com{'"'}), vous acceptez d{"'"}etre lie par les presentes conditions d{"'"}utilisation. Si vous n{"'"}acceptez pas ces conditions, veuillez ne pas utiliser le service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Description du service</h2>
            <p>
              Forfaits Vacances Tracker est un outil de suivi des prix de forfaits vacances tout inclus offerts par Air Canada Vacations et Air Transat. Le service permet aux utilisateurs de :
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Ajouter des forfaits vacances a suivre en collant l{"'"}URL du forfait.</li>
              <li>Recevoir des notifications par courriel lorsque le prix d{"'"}un forfait change.</li>
              <li>Consulter l{"'"}historique des prix sous forme de graphique.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Inscription et compte</h2>
            <p className="mb-3">Pour utiliser le service, vous devez creer un compte en :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Vous connectant avec votre compte Google, ou</li>
              <li>Vous inscrivant avec une adresse courriel et un mot de passe, apres avoir fourni un code d{"'"}invitation valide.</li>
            </ul>
            <p className="mt-3">
              Vous etes responsable de maintenir la confidentialite de vos informations de connexion et de toute activite effectuee sous votre compte.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Utilisation acceptable</h2>
            <p className="mb-3">En utilisant le service, vous vous engagez a :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Fournir des informations exactes lors de l{"'"}inscription.</li>
              <li>Utiliser le service uniquement a des fins personnelles et non commerciales.</li>
              <li>Ne pas tenter de contourner les mesures de securite du service.</li>
              <li>Ne pas utiliser le service de maniere abusive (ex. : ajout excessif de forfaits pour surcharger le systeme).</li>
              <li>Respecter les conditions d{"'"}utilisation des sites tiers (Air Canada Vacations, Air Transat).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Exactitude des informations</h2>
            <p>
              Les prix affiches sont obtenus automatiquement a partir des sites Web d{"'"}Air Canada Vacations et d{"'"}Air Transat. Bien que nous nous efforcions de fournir des informations exactes, nous ne garantissons pas l{"'"}exactitude, l{"'"}exhaustivite ou l{"'"}actualite des prix affiches. Les prix reels peuvent varier et doivent toujours etre verifies directement sur le site du fournisseur avant toute reservation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Limitation de responsabilite</h2>
            <p className="mb-3">
              Forfaits Vacances Tracker est fourni {'"'}tel quel{'"'} et {'"'}selon disponibilite{'"'}. Nous ne sommes pas responsables de :
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Toute inexactitude dans les prix affiches ou les notifications envoyees.</li>
              <li>Toute perte financiere resultant de decisions prises sur la base des informations fournies par le service.</li>
              <li>Toute interruption temporaire du service due a des mises a jour, des problemes techniques ou des modifications des sites tiers.</li>
              <li>Tout changement dans la structure des sites Web surveilles pouvant affecter la collecte des prix.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Propriete intellectuelle</h2>
            <p>
              Le contenu, le design et le code de Forfaits Vacances Tracker sont proteges par le droit d{"'"}auteur. Vous ne pouvez pas copier, modifier, distribuer ou reproduire le service sans autorisation ecrite prealable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Notifications par courriel</h2>
            <p>
              En utilisant le service, vous consentez a recevoir des notifications par courriel concernant les changements de prix des forfaits que vous suivez. Ces notifications sont envoyees a l{"'"}adresse courriel associee a votre compte. Vous pouvez cesser de recevoir des notifications en supprimant vos forfaits suivis ou en supprimant votre compte.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Suspension et resiliation</h2>
            <p>
              Nous nous reservons le droit de suspendre ou de resilier votre acces au service a tout moment, sans preavis, en cas de violation des presentes conditions d{"'"}utilisation ou d{"'"}utilisation abusive du service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">10. Modifications des conditions</h2>
            <p>
              Nous pouvons modifier ces conditions d{"'"}utilisation a tout moment. Les modifications prennent effet des leur publication sur cette page. Votre utilisation continue du service apres la publication des modifications constitue votre acceptation des nouvelles conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">11. Droit applicable</h2>
            <p>
              Les presentes conditions sont regies par les lois de la province de Quebec et les lois federales du Canada qui s{"'"}y appliquent. Tout litige relatif a ces conditions sera soumis a la competence exclusive des tribunaux du Quebec.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">12. Contact</h2>
            <p>
              Pour toute question concernant ces conditions d{"'"}utilisation, veuillez nous contacter a : <a href="mailto:contact@trackvacances.com" className="text-blue-400 hover:underline">contact@trackvacances.com</a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-white/30 text-xs">
          Forfaits Vacances Tracker &mdash; trackvacances.com
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
